import { UserSymbol } from '@d/auth/helper/auth'

export function getTenant(): string {
  const user = inject(UserSymbol)
  const tenant = computed(() => user?.value?.profile.aud[user?.value.profile.aud.length - 2])
  if (!tenant.value) {
    console.log('No tenant found')
    return 'unknown'
  }
  return tenant.value
}
